// navigationConfig.js
import {
  BusinessCenter as ManagementNavIcon,
  DashboardOutlined as DashboardIcon,
  HomeOutlined as HomeIcon,
  ListAlt as ListAltIcon,
  AccountCircle as AccountCircleIcon,
  LibraryBooks as LibraryBooksIcon,
  AccountTree as AccountTreeIcon,
  TrendingUp as TrendingUpIcon,
  Favorite as ReproductionIcon,
  LocalHospital as HealthIcon,
  ExitToApp as ManagementIcon,
  BubbleChart as SamplingIcon,
  InfoOutlined as AboutIcon,
  Security as PrivacyIcon,
  Share as DataSharingIcon,
  Gavel as GovernanceIcon,
  Settings as SysSettingsIcon,
} from '@material-ui/icons';

const ICONS = {
  home: HomeIcon,
  dashboard: DashboardIcon,
  management: ManagementNavIcon,
  list: ListAltIcon,
  account: AccountCircleIcon,
  reports: LibraryBooksIcon,
  tree: AccountTreeIcon,
  production: TrendingUpIcon,
  reproduction: ReproductionIcon,
  health: HealthIcon,
  eventManagement: ManagementIcon,
  sampling: SamplingIcon,
  governance:  GovernanceIcon,
  about:       AboutIcon,
  privacy:     PrivacyIcon,
  dataSharing: DataSharingIcon,
  sysSettings: SysSettingsIcon,
};

const createPage = (title, href, icon, children = [], opts = {}) => ({
  title,
  href,
  icon: ICONS[icon] || null,
  children,
  ...opts,
});

const navigationConfig = [
  {
    id: 'main',
    title: '',
    pages: [
      createPage('Overview', '/overview', 'home'),

      createPage('Dashboards', '/dashboards', 'dashboard', [
        createPage('Analytics', '/dashboards/analytics'),
      ], { defaultOpen: true }),

      createPage('Management', '/management', 'management', [
        createPage('Farms', '/management/farms/view/0'),
        createPage('Herds', '/management/herds'),
        createPage('Animals', '/management/animals'),
        createPage('Exit List', '/management/exit-list'),
        createPage('Partners', '/settings/partners/service-providers', 'tree', [
          createPage('Service Providers', '/settings/partners/service-providers'),
          createPage('Agents', '/settings/partners/agents'),
        ]),
      ], { defaultOpen: true }),

      createPage('Batch Processing', '/batch-processing', 'list'),

      createPage('Reports', '/reports', 'reports', [
        createPage('All Events', '/reports/events/all'),

        createPage('Production', null, 'production', [
          createPage('Milking', '/reports/events/milking'),
          createPage('Weight & Growth', '/reports/events/weight'),
        ]),

        createPage('Reproduction', null, 'reproduction', [
          createPage('Insemination', '/reports/events/ai'),
          createPage('Calving', '/reports/events/calving'),
          createPage('Pregnancy Diagnosis', '/reports/events/pd'),
          createPage('Synchronisation', '/reports/events/sync'),
        ]),

        /* Health hidden — preserved for future use
        createPage('Health', null, 'health', [
          createPage('Treatments', '/reports/events/health'),
        ]),
        */

        createPage('Sampling', null, 'sampling', [
          createPage('Methane', '/reports/events/methane'),
        ]),

        createPage('Management', null, 'eventManagement', [
          createPage('Exit & Disposal', '/reports/events/exit'),
        ]),
      ]),
    ],
  },

  {
    id: 'governance',
    title: 'Legal & Info',
    pages: [
      createPage('About',              '/info/about',           'about'),
      createPage('Privacy Policy',     '/info/privacy-policy',  'privacy'),
      createPage('Data & Governance',  '/info/data-governance', 'governance'),
    ],
  },
];

export default navigationConfig;
